import { render, staticRenderFns } from "./ToysList.vue?vue&type=template&id=f57d6200"
import script from "./ToysList.vue?vue&type=script&lang=js"
export * from "./ToysList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports